// Pemformatan untuk UI — semua teks melalui kamus bahasa semasa.

import { t } from './i18n.js';
import { money, pct as pctShared, formatDate, formatTimestamp, monthLabel as monthLabelShared } from '../../../shared/i18n/format.js';

export function rm(minor, { sign = false } = {}) {
  const s = money(minor);
  return sign && Number(minor) > 0 ? `+${s}` : s;
}
export const rmExact = (minor) => money(minor, { exact: true });
export const pct = pctShared;

export function toMinorInput(v) {
  const s = String(v ?? '').trim();
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
  const [w, f = ''] = s.split('.');
  return Number(w) * 100 + Number((f + '00').slice(0, 2));
}

export const fmtDate = (iso) => formatDate(t, iso);
export const fmtDateShort = (iso) => formatDate(t, iso, { short: true });
export const fmtTs = (ms, withTime = true) => formatTimestamp(t, ms, withTime);
export const monthLabel = (ym) => monthLabelShared(t, ym);
export const monthFull = (m) => t(`date.months.${m}`);
export const weekdays = () => [0, 1, 2, 3, 4, 5, 6].map((d) => t(`date.weekdays_short.${d}`));

export function addDays(iso, n) {
  const d = new Date(iso + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
export function nights(a, b) {
  return Math.round((Date.parse(b + 'T00:00:00Z') - Date.parse(a + 'T00:00:00Z')) / 86400000);
}

// Nada warna status (label daripada kamus: bstatus.* / status.*)
export const BOOKING_TONE = {
  PENDING_PAYMENT: 'warn', PAYMENT_PROCESSING: 'warn', CONFIRMED: 'ok', CHECKED_IN: 'info', COMPLETED: '',
  CANCELLED: 'bad', REFUND_PENDING: 'warn', REFUNDED: 'bad', DISPUTED: 'bad',
};
export const STATUS_TONE = {
  ACTIVE: 'ok', DRAFT: '', PENDING_REVIEW: 'warn', INACTIVE: '', REJECTED: 'bad', SUSPENDED: 'bad', DELETED: 'bad', REQUESTED: 'warn',
  PROCESSING: 'info', APPROVED: 'info', PAID: 'ok', FAILED: 'bad', CANCELLED: 'bad', PENDING: 'warn', VERIFIED: 'ok', NONE: '', OPEN: 'warn',
  UNDER_REVIEW: 'info', RESOLVED: 'ok', COMPLETED: 'ok', MANUAL_REQUIRED: 'warn', REVERSED: '', VISIBLE: 'ok', HIDDEN: 'bad', CREATED: '',
  AMOUNT_MISMATCH: 'bad', AVAILABLE: 'ok', CLOSED: '', UNPAID: 'warn',
};

// Label nama tempat/kategori ikut bahasa
export const stateName = (s) => t(`state.${s}`);
export const typeName = (k) => t(`ptype.${k}`);
export function categoryName(c) {
  const key = `category.${c.id}`;
  const v = t(key);
  if (v !== key) return v;
  return c.names?.[t.locale] || c.names?.ms || c.name;
}
